export const userDisplayName = user =>
  user.first_name
    ? user.last_name
      ? `${user.first_name} ${user.last_name}`
      : user.first_name
    : user.email



// WEBPACK FOOTER //
// ./src/utils/user.js